var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["editorModule", { inverse: !_vm.standalone }] },
    [
      _vm.standalone
        ? _c("AppHeaderView", {
            attrs: { collapsed: _vm.headerCollapsed, "show-cart": true },
            on: { collapse: _vm.onHeaderCollapse },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.standalone
        ? _c(
            "SubnavbarView",
            {
              attrs: {
                "has-next": false,
                "has-price": _vm.showPricing,
                "show-status": true,
                "fixed-position": true,
              },
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.$t("buttonReady")) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "workspace" } }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("EditorView", {
              attrs: {
                standalone: _vm.standalone,
                "page-index": _vm.pageIndex,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.pageModel
        ? _c("EditorToolbarView", { attrs: { "page-model": _vm.pageModel } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }